// Local replacement for @codemaniack/form-builder FormInput
import React from 'react';
import { Form } from 'react-bootstrap';
import './FormInput.less';

const FormInput = ({
  label,
  type = 'text',
  name,
  placeholder,
  value,
  onValueChange,
  onChange,
  onBlur,
  required = false,
  error,
  className = '',
  inputRef,
  icon,
  disabled = false,
  ...rest
}) => {
  const handleChange = (e) => {
    if (onValueChange) {
      onValueChange(e);
    }
    if (onChange) {
      onChange(e);
    }
  };

  const inputClasses = `form-control ${error ? 'is-invalid' : ''} ${className}`;
  
  return (
    <Form.Group className="mb-3 form-input-group">
      {label && (
        <Form.Label>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </Form.Label>
      )}
      <div className="input-wrapper">
        <Form.Control
          ref={inputRef}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          className={icon ? 'with-icon' : ''}
          isInvalid={!!error}
          disabled={disabled}
          {...rest}
        />
        {icon && <span className="input-icon">{icon}</span>}
      </div>
      {error && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default FormInput;
